import {
  removeTrailingSlashes,
  removeRouterBasename,
  removeStartingSlash,
} from '../locationUtils';

export const clearActiveTableOfContentLinks = () => {
  const activeTableOfContentLinks = document.querySelectorAll(
    `ol[id^="toc-"] li[data-active="true"]`
  );
  activeTableOfContentLinks.forEach((element) => {
    element.removeAttribute('data-active');
  });
};

const isTableOfContentLinkActive = (articleName, hash, routerBasename) => {
  if (!hash) {
    return false;
  }
  const tableOfContentLinkSelector = `ol[id="toc-${articleName}"] li a[href="${routerBasename}/${articleName}#${hash}"]`;
  const linkElement = document.querySelector(tableOfContentLinkSelector);
  return linkElement && linkElement.parentElement.getAttribute('data-active');
};

export const isActiveSectionUnactivated = (entry, routerBasename) => {
  if (entry.isIntersecting) {
    return false;
  }
  try {
    const [articleName, hash] = entry.target.id.split('#');
    return isTableOfContentLinkActive(articleName, hash, routerBasename);
  } catch (err) {
    return false;
  }
};

const activateTableOfContentLink = (
  hash,
  routerBasename,
  shouldDisableTocScroll
) => {
  try {
    const markdownPath = removeTrailingSlashes(
      removeStartingSlash(
        removeRouterBasename(window.location.pathname, routerBasename)
      )
    );
    const newActiveLinkSelector = `ol[id="toc-${markdownPath}"] li a[href="${routerBasename}/${markdownPath}${window.location.search}#${hash}"]`;
    const newActiveLinkElement = document.querySelector(newActiveLinkSelector);
    if (newActiveLinkElement) {
      newActiveLinkElement.parentElement.setAttribute('data-active', 'true');
      if (!shouldDisableTocScroll) {
        newActiveLinkElement.scrollIntoView({ block: 'nearest' });
      }
    }
  } catch (err) {
    // TODO: handle query failure selector properly
  }
};

export const updateActiveTableOfContentLink = (
  hash,
  routerBasename,
  shouldDisableTocScroll
) => {
  clearActiveTableOfContentLinks();
  activateTableOfContentLink(hash, routerBasename, shouldDisableTocScroll);
};
